import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { HoverHintTrigger } from "@/components/ui/title-help";
import {
  buildInsideSalesCustomerPath,
  EndUserDetailHoverHint,
} from "@/components/inside-sales/EndUserDetailHoverHint";
import { cn } from "@/lib/utils";

const DETAIL_LINK_CLASS =
  "font-medium text-sky-700 hover:text-sky-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-1";

export function EndUserDetailLink({
  fsAccountId,
  endUserName,
  className,
  children,
  block = false,
}: {
  fsAccountId: number | null | undefined;
  endUserName?: string | null;
  className?: string;
  children?: ReactNode;
  block?: boolean;
}): ReactNode {
  const label =
    children ??
    (endUserName != null && endUserName.trim() !== "" ? endUserName.trim() : "—");
  if (fsAccountId == null || !Number.isFinite(fsAccountId) || fsAccountId <= 0) {
    return <span className={className}>{label}</span>;
  }

  return (
    <HoverHintTrigger
      block={block}
      align="start"
      trigger={
        <Link
          to={buildInsideSalesCustomerPath(fsAccountId)}
          className={cn(DETAIL_LINK_CLASS, block ? "block truncate" : undefined, className)}
        >
          {label}
        </Link>
      }
    >
      <EndUserDetailHoverHint fsAccountId={fsAccountId} />
    </HoverHintTrigger>
  );
}
